// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconSitemap, IconUsers, IconDashboard } from '@tabler/icons-react';

// constant
const icons = {
    IconSitemap,
    IconUsers,
    IconDashboard
};

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const healthContent = {
    id: 'health-content',
    type: 'group',
    title: <FormattedMessage id="health-content" />,
    children: [
        {
            id: 'overall-score',
            title: <FormattedMessage id="status-market" />,
            type: 'item',
            url: '/loolu/admin/health-content/overall-score',
            icon: icons.IconDashboard,
            external: false,
            breadcrumbs: false
        }
    ]
};

export default healthContent;
